import React from 'react';
import { motion } from 'framer-motion';
import { Users, Target, Award, TrendingUp } from 'lucide-react';
import './AboutSection.css';

const AboutSection: React.FC = () => {
  const values = [
    {
      icon: Target,
      title: 'Precision',
      description: 'We ensure the right person for the right job at the right time.'
    },
    {
      icon: Users,
      title: 'Empowerment',
      description: 'We empower others to achieve their full potential and leadership capabilities.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We maintain the highest standards in talent acquisition and placement.'
    },
    {
      icon: TrendingUp,
      title: 'Growth',
      description: 'We focus on sustainable growth for both candidates and organizations.'
    }
  ];

  return (
    <section id="about" className="about-section section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Who We Are</h2>
          <p className="section-subtitle">
            Future Tech HR Services Private Limited - Connecting talent with opportunities since 2013
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="about-intro">
              <h3>Finding, Connecting, Building Success</h3>
              <p>
                Future Tech HR Services Private Limited recruitment company as a brand was 
                established in year 2013, with an inspiring ideology that matches each human 
                potential & talent through integrated tech based solutions to the job that 
                is seeking them!
              </p>
            </div>

            <div className="about-philosophy">
              <h4>Our Philosophy</h4>
              <p>
                Being a leader is not just about enriching self but also to empower others. 
                We take pride in ensuring that we do not just seal the gap between the job 
                seeker & employer but we scout for talent that has the ability to lead, 
                sustain & thrive.
              </p>
            </div>

            <div className="about-unique">
              <h4>What Makes Us Unique</h4>
              <p>
                Our ability to filter the right talent for the right job & bring out the 
                best human capabilities the task requires. When you have the right person 
                at the right place and the right time, then it's just about time that the 
                magic will follow!
              </p>
            </div>
          </motion.div>

          <motion.div
            className="about-visual"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="values-grid">
              {values.map((value, index) => (
                <motion.div
                  key={value.title}
                  className="value-card card"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -5 }}
                >
                  <div className="value-icon">
                    <value.icon size={28} />
                  </div>
                  <h4>{value.title}</h4>
                  <p>{value.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        <motion.div
          className="company-highlights"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <div className="highlight-card">
            <div className="highlight-content">
              <h4>Established Excellence</h4>
              <p>Since 2013, we've been connecting talent with opportunities across diverse industries.</p>
            </div>
            <div className="highlight-year">2013</div>
          </div>
          
          <div className="highlight-card">
            <div className="highlight-content">
              <h4>Tech-Driven Solutions</h4>
              <p>Integrated technology-based solutions for efficient talent matching and placement.</p>
            </div>
            <div className="highlight-icon">🚀</div>
          </div>
          
          <div className="highlight-card">
            <div className="highlight-content">
              <h4>Leadership Focus</h4>
              <p>We scout for talent that has the ability to lead, sustain, and thrive.</p>
            </div>
            <div className="highlight-icon">👑</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
